export const INTERNAL_ERROR_PATH = '/error';
export const UMR_ELIGIBILITY_ERROR_PATH = '/error/eligibility';
export const PSX_BLUE_GREEN_CANARY_SESSION_STORAGE_KEY =
  'psxBlueGreenCanaryColor';
